/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliSchoolCycleDto } from '../../models/amoxcalli-school-cycle-dto';

export interface ApiCyclesIdGet$Plain$Params {
  id: string;
}

export function apiCyclesIdGet$Plain(http: HttpClient, rootUrl: string, params: ApiCyclesIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AmoxcalliSchoolCycleDto>> {
  const rb = new RequestBuilder(rootUrl, apiCyclesIdGet$Plain.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AmoxcalliSchoolCycleDto>;
    })
  );
}

apiCyclesIdGet$Plain.PATH = '/api/cycles/{id}';
